import {
    Maybe,
    ConfigurableProduct,
    SelectedConfigurableOption
} from '@pylot-data/pylotschema'

export type GetUiForConfigProductArgs = {
    product?: Maybe<ConfigurableProduct>
    options?: Maybe<Maybe<SelectedConfigurableOption>[]>
}

/**
 * Get uid for config products would be alterative | temp solution
 * Native magento wishlist query has configurable_option { configurable_product_option_value_uid }
 * which is throwing error (Native bug) and once its resolved
 * this function can be removed and access uid directly from { item { configurable_product_option_value_uid } }
 * @param product ConfigurableProduct
 * @param options SelectedConfigurableOption
 * @returns string[]
 */
export const getUidForConfigProducts = ({
    product,
    options
}: GetUiForConfigProductArgs): string[] => {
    if (!product || !options?.length) return [] //return if not a config product

    const selectedUid: Array<string> = []

    options?.forEach((configOptions) => {
        //using some to terminate the loop when condition satisfies for first time
        product?.variants?.some((variant) => {
            const attrUid = variant?.attributes?.find((attr) => {
                return attr?.value_index === configOptions?.value_id
            })

            if (typeof attrUid !== 'undefined') {
                selectedUid.push(attrUid?.uid!)
                return true // break the loop
            }
        })
    })

    return selectedUid
}
